import { Account } from '@brenger/api-client';
import { getIdFromIri } from '@brenger/utils';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../hooks';
import { CacheKey } from '../../../types';
import { priceClient } from '../../../utils/request';
import { actions } from '../ducks';

/**
 * Loads the account's active volume discount so the banner can show a percentage
 * before a full quote exists.
 */
export const useActiveDiscount = (): void => {
  const account = useTypedSelector(state => state.user.userData?.account as Account | undefined);
  const accountId = getIdFromIri(account?.['@id']);
  const dispatch = useDispatch();

  const discount = useQuery({
    queryKey: [CacheKey.RETRIEVE_ACTIVE_DISCOUNT, accountId],
    queryFn: () => priceClient.discounts.retrieveActive({ accountId: accountId as string }),
    enabled: !!accountId,
  });

  React.useEffect(() => {
    if (!accountId || discount.isError) {
      dispatch(actions.setDiscountPercentageBasisPoints(null));
      return;
    }
    if (!discount.isSuccess) return;
    dispatch(actions.setDiscountPercentageBasisPoints(discount.data?.percentage_basis_points ?? null));
  }, [accountId, discount.data, discount.isError, discount.isSuccess, dispatch]);
};
